import styled from 'styled-components'
import Heading from 'components/Heading'
import { Box } from 'components/Box'

const H3 = styled(Heading.H3)`
  margin: 20px 0;
`

const Separator = styled(Box).attrs({
  height: 1,
  bg: 'border.dark.base',
})``

export { H3, Separator }
